/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Brand_PurchaseInputs */

const en_price_brand_purchase = /** @type {(inputs: Price_Brand_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand purchase`)
};

/**
* | output |
* | --- |
* | "Brand purchase" |
*
* @param {Price_Brand_PurchaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_brand_purchase = /** @type {((inputs?: Price_Brand_PurchaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Brand_PurchaseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_brand_purchase(inputs)
});